import { useEffect, useRef } from "react";
import { styled } from "stitches.config";
import * as $segment from "@/utils/segment";
import { SimulatorActionBlock } from "../simulators/SimulatorActionBlock";
import { SimulatorShareResult } from "../simulators/SimulatorShareResult";
import { MonthlyPaymentsForm } from "./MonthlyPaymentsForm";
import { useMonthlyPaymentsSimulatorForm } from "@/hooks/simulators/useMonthlyPaymentsSimulatorForm";
import { MonthlyPaymentsResultValues } from "./MonthlyPaymentsResultValues";
import { calculateMonthlyPaymentGraphData, calculateMonthlyPaymentWithInsurance } from "@/utils/simulators";
import { MonthlyPaymentsGraph } from "./MonthlyPaymentsGraph";

const SIMULATOR_NAME = 'monthly_payments';

export const MonthlyPaymentsSimulatorSection = () => {
    const { form, loanCapital, insuranceRate, interestRate, isInvalid, numbersOfYears } = useMonthlyPaymentsSimulatorForm();

    useEffect(() => {
        $segment.event('simulator_started', { simulator: SIMULATOR_NAME });
    }, []);

    const resultsTrackedRef = useRef(false);
    useEffect(() => {
        if (!isInvalid && !resultsTrackedRef.current) {
            resultsTrackedRef.current = true;
            $segment.event('simulator_results_shown', { simulator: SIMULATOR_NAME });
        }
    }, [isInvalid]);

    const monthlyPayments = calculateMonthlyPaymentWithInsurance({
      loanCapital,
      interestRate, 
      months: numbersOfYears * 12,
      insuranceRate
    })

    const loanTotalCost =  monthlyPayments * numbersOfYears * 12 - loanCapital
    const insurancePerMonth = loanCapital * insuranceRate / 12
    const insuranceTotalCost = insurancePerMonth * numbersOfYears * 12

    const graphData = calculateMonthlyPaymentGraphData({
      insurancePerMonth,
      interestRate,
      loanCapital,
      monthlyPayments,
      numbersOfYears,
    });

    return (
      <Container>
        <FormContainer>
          <MonthlyPaymentsForm register={form.register} />
          <SimulatorActionBlock utmCampaign="simulators_tools_monthlypayments" />
        </FormContainer>
        <GraphContainer>
          <MonthlyPaymentsResultValues monthlyPayments={monthlyPayments} insurancePerMonth={insurancePerMonth} insuranceTotalCost={insuranceTotalCost} loanTotalCost={loanTotalCost} isInvalid={isInvalid} />
          <MonthlyPaymentsGraph nbYears={numbersOfYears} graphData={graphData} monthlyPayments={monthlyPayments} displayPlaceholder={isInvalid} />
          <InfosContainer>
            <SimulatorShareResult />
          </InfosContainer>
        </GraphContainer>
      </Container>
    )   
}

const Container = styled('section', {
    backgroundColor: 'black',
    border: '1px solid $borderOpacity',
    borderRadius: '$4',
    width: '100%',
    maxWidth: '1032px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    '@sm': {
      gridTemplateColumns: '1fr',
    }
  });

  const FormContainer = styled('div', {
    borderRight: '1px solid $borderSecondary',
  });

  const GraphContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '$10',
    padding: '$10 0',
  });


  const InfosContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '$6',
    padding: '0 $10',
  })

